import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

import OptionGroup from "./OptionGroup";

export class index extends Component {
  checkCondition = (option, checkGroups = false) => {
    if (!option.condition_parent) return true;
    const { selectedOptions, options } = this.props;
    let parentSelected =
      !!selectedOptions[option.condition_parent_option]?.selectedOptions?.[
        option.condition_parent
      ];

    if (!parentSelected && checkGroups) {
      const parent = options.find(
        (op) => op.id === option.condition_parent_option
      );
      if (parent?.groups?.length) {
        return parent?.groups.some(
          (group) =>
            selectedOptions[`${option.condition_parent_option}-${group}`]
              ?.selectedOptions?.[option.condition_parent]
        );
      }
    }

    return parentSelected;
  };
  render() {
    const {
      t,
      options,
      selectedOptions,
      productUsedComponents,
      productQuantity,
      editedProduct,
      optionsGroups,
    } = this.props;
    let optionGroups = [];
    if (optionsGroups.length > 0) {
      optionGroups = optionsGroups.map((og) => (
        <span key={og.id} sortOrder={og.sort_order}>
          {options
            .filter((o) => !o.condition_parent && o.groups.includes(og.id))
            .map((option, index) => (
              <OptionGroup
                key={`${og?.id || ""} ${index}-${option.id}`}
                option={option}
                productUsedComponents={productUsedComponents}
                addOptionToProduct={this.props.addOptionToProduct}
                selectedOverall={
                  selectedOptions[option.id + "-" + og.id]
                    ? selectedOptions[option.id + "-" + og.id].selected
                    : 0
                }
                selectedOptions={
                  selectedOptions[option.id + "-" + og.id]
                    ? selectedOptions[option.id + "-" + og.id].selectedOptions
                    : {}
                }
                productQuantity={productQuantity}
                editedProduct={editedProduct}
                group={og}
                onOpenConditionalModal={this.props.onOpenConditionalModal}
                allOptions={this.props.allOptions}
              />
            ))}
        </span>
      ));

      options.forEach((option, index) => {
        if (
          option.groups.length <= 0 &&
          !option.condition_parent &&
          this.checkCondition(option, true)
        ) {
          optionGroups.push(
            <OptionGroup
              key={`${index}-${option.id}`}
              option={option}
              productUsedComponents={productUsedComponents}
              addOptionToProduct={this.props.addOptionToProduct}
              selectedOverall={
                selectedOptions[option.id]
                  ? selectedOptions[option.id].selected
                  : 0
              }
              selectedOptions={
                selectedOptions[option.id]
                  ? selectedOptions[option.id].selectedOptions
                  : {}
              }
              productQuantity={productQuantity}
              editedProduct={editedProduct}
              sortOrder={option.sort_order}
              onOpenConditionalModal={this.props.onOpenConditionalModal}
              allOptions={this.props.allOptions}
            />
          );
        }
      });
      optionGroups.sort((a, b) => a.props.sortOrder - b.props.sortOrder);
    } else {
      optionGroups = options

        .filter(
          (option) => !option.condition_parent && this.checkCondition(option)
        )
        .map((option, index) => (
          <OptionGroup
            key={`${index}-${option.id}`}
            option={option}
            productUsedComponents={productUsedComponents}
            addOptionToProduct={this.props.addOptionToProduct}
            selectedOverall={
              selectedOptions[option.id]
                ? selectedOptions[option.id].selected
                : 0
            }
            selectedOptions={
              selectedOptions[option.id]
                ? selectedOptions[option.id].selectedOptions
                : {}
            }
            productQuantity={productQuantity}
            editedProduct={editedProduct}
            onOpenConditionalModal={this.props.onOpenConditionalModal}
            allOptions={this.props.allOptions}
          />
        ));
    }
    return (
      <div className="my-4  ">
        <p style={{ fontSize: 20 }} className=" mt-5 text-center">
          {t("Options")}
        </p>
        {optionGroups}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(index));
